export default "__VITE_ASSET__0c8aec8b__"